(function () {
  'use strict';

  function initBlock2(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock2) return;
    root.__nbpAssetBlock2 = true;
const modal = root ? root.querySelector('[data-nb-product-modal]') : null;
        if (!root || !modal) return;
        if (modal.parentNode !== sectionRoot) sectionRoot.appendChild(modal);

        const cards = Array.from(root.querySelectorAll('[data-nb-carousel-src]')).filter(card => card.dataset.nbCarouselSrc);
        const image = modal.querySelector('.nb-product-modal__image');
        const dots = modal.querySelector('.nb-product-modal__dots');
        let index = 0;
        const mainCard = root.querySelector('.nb-product-media-card--main');
        const mainImage = mainCard ? mainCard.querySelector('[data-nb-media-img]') : null;
        let mobileIndex = 0;
        let mobilePeek = null;
        let mobileDots = null;
        let mobileStartX = null;
        let mobileStartY = null;
        let mobileDidSwipe = false;
        let mobileLastSwipeAt = 0;

        function isMobileProduct() {
          return window.matchMedia('(max-width: 760px)').matches;
        }

        function carouselSrcAt(nextIndex) {
          if (!cards.length) return '';
          const card = cards[(nextIndex + cards.length) % cards.length];
          const img = card ? card.querySelector('[data-nb-media-img]') : null;
          return (card && card.dataset.nbCarouselSrc) || (img && (img.currentSrc || img.src)) || '';
        }

        function positionMobilePeek() {
          if (!mainCard || !mobilePeek || !isMobileProduct()) return;
          const rect = mainCard.getBoundingClientRect();
          const visibleSliver = 9;
          const viewportRight = document.documentElement.clientWidth || window.innerWidth;
          const edgeOffset = viewportRight - rect.left - visibleSliver;
          const peekLeft = Math.round(Math.max(rect.width + 4, edgeOffset));
          mainCard.style.setProperty('--nb-mobile-peek-left', `${peekLeft}px`);
          mobilePeek.style.setProperty('left', `${peekLeft}px`, 'important');
        }

        function ensureMobileCarousel() {
          if (!mainCard || !mainImage) return;

          if (!mobilePeek) {
            mobilePeek = document.createElement('img');
            mobilePeek.className = 'nb-mobile-peek-img';
            mobilePeek.alt = '';
            mobilePeek.setAttribute('aria-hidden', 'true');
            mainCard.appendChild(mobilePeek);
          }

          if (!mobileDots) {
            mobileDots = document.createElement('div');
            mobileDots.className = 'nb-mobile-carousel-dots';
            mainCard.appendChild(mobileDots);
          }

          if (mainCard.dataset.nbMobileCarouselReady === 'true') return;
          mainCard.dataset.nbMobileCarouselReady = 'true';

          function handleSwipe(deltaX, deltaY) {
            if (Math.abs(deltaX) < 28 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return false;
            const now = Date.now();
            if (now - mobileLastSwipeAt > 180) {
              updateMobileCarousel(mobileIndex + (deltaX < 0 ? 1 : -1));
            }
            mobileLastSwipeAt = now;
            mobileDidSwipe = true;
            window.setTimeout(() => { mobileDidSwipe = false; }, 260);
            return true;
          }

          mainCard.addEventListener('click', (event) => {
            if (!isMobileProduct()) return;
            if (event.target.closest('.nb-product-zoom') || event.target.closest('.nb-mobile-carousel-dot')) return;
            if (mobileDidSwipe) {
              event.preventDefault();
              return;
            }
            event.preventDefault();
            open(mainCard, mobileIndex);
          });

          mainCard.addEventListener('pointerdown', (event) => {
            if (!isMobileProduct() || event.target.closest('button')) return;
            mobileStartX = event.clientX;
            mobileStartY = event.clientY;
          });

          mainCard.addEventListener('pointerup', (event) => {
            if (!isMobileProduct() || mobileStartX === null || mobileStartY === null) return;
            const deltaX = event.clientX - mobileStartX;
            const deltaY = event.clientY - mobileStartY;
            mobileStartX = null;
            mobileStartY = null;
            handleSwipe(deltaX, deltaY);
          });

          mainCard.addEventListener('pointercancel', () => {
            mobileStartX = null;
            mobileStartY = null;
          });

          mainCard.addEventListener('touchstart', (event) => {
            if (!isMobileProduct() || event.target.closest('button')) return;
            const touch = event.touches[0];
            if (!touch) return;
            mobileStartX = touch.clientX;
            mobileStartY = touch.clientY;
          }, { passive: true });

          mainCard.addEventListener('touchend', (event) => {
            if (!isMobileProduct() || mobileStartX === null || mobileStartY === null) return;
            const touch = event.changedTouches[0];
            if (!touch) return;
            const handled = handleSwipe(touch.clientX - mobileStartX, touch.clientY - mobileStartY);
            mobileStartX = null;
            mobileStartY = null;
            if (handled) event.preventDefault();
          }, { passive: false });
        }

        function updateMobileCarousel(nextIndex = mobileIndex) {
          if (!mainCard || !mainImage || !cards.length) return;
          ensureMobileCarousel();
          mobileIndex = (nextIndex + cards.length) % cards.length;
          const currentSrc = carouselSrcAt(mobileIndex);
          const nextSrc = carouselSrcAt(mobileIndex + 1);

          if (currentSrc && mainImage.src !== currentSrc) mainImage.src = currentSrc;
          if (mobilePeek && nextSrc) mobilePeek.src = nextSrc;
          positionMobilePeek();
          requestAnimationFrame(positionMobilePeek);
          window.setTimeout(positionMobilePeek, 120);
          if (!mobileDots) return;

          mobileDots.innerHTML = cards.map((_, i) => `<button class="nb-mobile-carousel-dot ${i === mobileIndex ? 'is-active' : ''}" type="button" aria-label="Show product image ${i + 1}"></button>`).join('');
          mobileDots.querySelectorAll('button').forEach((button, i) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              updateMobileCarousel(i);
            });
          });
        }

        root.nbRefreshMobileCarousel = function (reset) {
          updateMobileCarousel(reset ? 0 : mobileIndex);
        };

        function renderDots() {
          if (!dots) return;
          dots.innerHTML = cards.map((_, i) => `<button class="${i === index ? 'is-active' : ''}" type="button" aria-label="Show expanded product image ${i + 1}"></button>`).join('');
          dots.querySelectorAll('button').forEach((button, i) => {
            button.addEventListener('click', () => show(i));
          });
        }

        function show(nextIndex) {
          if (!cards.length || !image) return;
          index = (nextIndex + cards.length) % cards.length;
          image.src = cards[index].dataset.nbCarouselSrc;
          renderDots();
        }

        function open(card, preferredIndex) {
          const found = Number.isFinite(preferredIndex) ? preferredIndex : cards.indexOf(card);
          show(found >= 0 ? found : 0);
          modal.hidden = false;
          modal.removeAttribute('hidden');
          modal.setAttribute('aria-hidden', 'false');
          sectionRoot.classList.add('is-nbp-modal-open');
          root.classList.add('is-nbp-modal-open');
          document.documentElement.style.overflow = 'hidden';
        }

        function close() {
          modal.hidden = true;
          modal.setAttribute('hidden', '');
          modal.setAttribute('aria-hidden', 'true');
          sectionRoot.classList.remove('is-nbp-modal-open');
          root.classList.remove('is-nbp-modal-open');
          document.documentElement.style.overflow = '';
        }

        root.querySelectorAll('.nb-product-zoom').forEach(button => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            const card = button.closest('[data-nb-carousel-src]');
            open(card, card === mainCard && isMobileProduct() ? mobileIndex : undefined);
          });
        });

        modal.querySelectorAll('[data-nb-modal-close]').forEach(button => button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          close();
        }));
        modal.addEventListener('click', (event) => {
          if (!event.target || !event.target.closest) return;
          const shouldStayOpen = event.target.closest('.nb-product-modal__image, [data-nb-modal-prev], [data-nb-modal-next], .nb-product-modal__dots');
          const closeRequested = event.target.closest('[data-nb-modal-close]');
          if (shouldStayOpen && !closeRequested) return;
          event.preventDefault();
          event.stopPropagation();
          close();
        });
        const prev = modal.querySelector('[data-nb-modal-prev]');
        const next = modal.querySelector('[data-nb-modal-next]');
        if (prev) prev.addEventListener('click', () => show(index - 1));
        if (next) next.addEventListener('click', () => show(index + 1));

        document.addEventListener('keydown', (event) => {
          if (modal.hidden) return;
          if (event.key === 'Escape') close();
          if (event.key === 'ArrowLeft') show(index - 1);
          if (event.key === 'ArrowRight') show(index + 1);
        });

        if (isMobileProduct()) updateMobileCarousel(0);
        window.addEventListener('resize', () => {
          if (isMobileProduct()) updateMobileCarousel(mobileIndex);
        });
  }
  function initBlock3(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock3) return;
    root.__nbpAssetBlock3 = true;
    if (!root) return;

        const addToCartButton = root.querySelector('[data-nb-atc-button]');
        const addToCartText = root.querySelector('[data-nb-atc-text]');
        const addToCartSpinner = root.querySelector('[data-nb-atc-spinner]');

        function openCartDrawer() {
          ['cart:refresh', 'cart:updated', 'upcart:open', 'upcart:item-added', 'cart:open', 'cart-drawer:open'].forEach(function(eventName) {
            document.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
            window.dispatchEvent(new CustomEvent(eventName));
          });
          if (window.Upcart && typeof window.Upcart.open === 'function') window.Upcart.open();
          if (window.Upcart && typeof window.Upcart.openCart === 'function') window.Upcart.openCart();
          if (window.upcart && typeof window.upcart.open === 'function') window.upcart.open();
          if (window.upCart && typeof window.upCart.open === 'function') window.upCart.open();
        }

        function setAddToCartBusy(isBusy) {
          if (!addToCartButton) return;
          addToCartButton.disabled = isBusy;
          if (addToCartText) addToCartText.hidden = isBusy;
          if (addToCartSpinner) addToCartSpinner.hidden = !isBusy;
          addToCartButton.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        }

        function numberOnly(value) {
          return parseInt(String(value || '').replace(/[^0-9]/g, ''), 10) || null;
        }

        function selectedFlavorIndex() {
          const checked = root.querySelector('input[name="flavour-image"]:checked');
          if (checked && checked.dataset.flavorIndex) return checked.dataset.flavorIndex;
          const all = Array.from(root.querySelectorAll('input[name="flavour-image"]'));
          const idx = all.indexOf(checked);
          return idx >= 0 ? String(idx + 1) : '1';
        }

        function selectedSupplyInput() {
          return root.querySelector('input[name="subscribe-save"]:checked') ||
            root.querySelector('.nb-supply-option.is-active input[name="subscribe-save"]') ||
            root.querySelector('input[name="subscribe-save"]');
        }

        function selectedComboValue(input, baseName) {
          if (!input) return '';
          const flavorIndex = selectedFlavorIndex();
          return input.getAttribute(`data-${baseName}-flavor${flavorIndex}`) ||
            input.getAttribute(`data-${baseName}`) ||
            '';
        }

        if (addToCartButton) {
          addToCartButton.addEventListener('click', function (event) {
            if (event) event.preventDefault();
            if (addToCartButton.disabled) return;

            setAddToCartBusy(true);

            const selectedSupply = selectedSupplyInput();
            const mainVariantId = numberOnly(selectedComboValue(selectedSupply, 'variant-id')) || parseInt(this.dataset.variantId, 10);
            if (!mainVariantId) {
              setAddToCartBusy(false);
              if (typeof showError === 'function') showError('Please choose an available product option.');
              return;
            }

            const selectedPlan = root.querySelector('input[name="loop-subscription-option"]:checked');
            const sellingPlanId = numberOnly(selectedComboValue(selectedSupply, 'selling-plan-id')) ||
              (selectedPlan && selectedPlan.value ? parseInt(selectedPlan.value, 10) : null);
            const item = {
              form_type: 'product',
              id: mainVariantId,
              quantity: 1
            };

            if (sellingPlanId) item.selling_plan = sellingPlanId;

            fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items: [item] })
            })
              .then((response) => response.json().catch(() => ({})).then((data) => ({ response, data })))
              .then(({ response, data }) => {
                if (!response.ok || data.status === 422) {
                  throw new Error(data.description || 'Error adding to cart');
                }
                if (typeof updateCartCount === 'function') updateCartCount();
                openCartDrawer();
                if (sectionRoot.getAttribute('data-nbp-redirect-to-checkout') === 'true') {
                  window.location.href = '/checkout';
                }
              })
              .catch((error) => {
                console.error('Error adding to cart:', error);
                if (typeof showError === 'function') showError(error.message || error.description || 'Error adding to cart');
              })
              .finally(() => {
                setAddToCartBusy(false);
              });
          });
        }
  }
  function initBlock4(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock4) return;
    root.__nbpAssetBlock4 = true;
if (!root) return;

        const themeDataEl = root.querySelector('[data-nb-flavor-themes]');
        if (!themeDataEl) return;

        let themes = {};
        try {
          themes = JSON.parse(themeDataEl.textContent || '{}');
        } catch (error) {
          console.warn('Unable to parse flavor themes', error);
          return;
        }

        let bgTimer = null;
        let waveTimer = null;

        function selectedFlavorIndex() {
          const selected = root.querySelector('input[name="flavour-image"]:checked');
          return selected ? selected.dataset.flavorIndex || '1' : '1';
        }

        function setMedia(slot, item) {
          if (!item || !item.src) return;
          const card = root.querySelector('[data-nb-media-slot="' + slot + '"]');
          if (!card) return;
      const image = card.querySelector('[data-nb-media-img]');
      card.dataset.nbCarouselSrc = item.full || item.src;
      if (!image || image.src === item.src) {
        return;
      }

          card.classList.add('is-swapping');
          window.setTimeout(() => {
            image.src = item.src;
            if (item.alt) image.alt = item.alt;
            card.dataset.nbCarouselSrc = item.full || item.src;
            card.classList.remove('is-swapping');
          }, 120);
        }

        function applyTheme(flavorIndex, animate) {
          const theme = themes[String(flavorIndex)] || themes['1'];
          if (!theme) return;

          const nextBg = theme.sectionBg || getComputedStyle(root).getPropertyValue('--nb-product-cream').trim() || '#fff0c8';
          const nextBenefit = theme.benefitBg || '#ffc233';

          (theme.media || []).forEach(item => setMedia(item.slot, item));
          if (typeof root.nbRefreshMobileCarousel === 'function') root.nbRefreshMobileCarousel(true);

          if (!animate || root.dataset.activeFlavor === String(flavorIndex)) {
            root.style.setProperty('--nb-active-bg', nextBg);
            root.style.setProperty('--nb-active-benefit-bg', nextBenefit);
            root.dataset.activeFlavor = String(flavorIndex);
            return;
          }

          root.style.setProperty('--nb-wave-bg', nextBg);
          root.classList.remove('is-flavor-waving');
          void root.offsetWidth;
          root.classList.add('is-flavor-waving');

          window.clearTimeout(bgTimer);
          window.clearTimeout(waveTimer);
          bgTimer = window.setTimeout(() => {
            root.style.setProperty('--nb-active-bg', nextBg);
            root.style.setProperty('--nb-active-benefit-bg', nextBenefit);
            root.dataset.activeFlavor = String(flavorIndex);
          }, 520);

          waveTimer = window.setTimeout(() => {
            root.classList.remove('is-flavor-waving');
          }, 860);
        }

        applyTheme(selectedFlavorIndex(), false);

        root.querySelectorAll('input[name="flavour-image"]').forEach(input => {
          input.addEventListener('change', () => applyTheme(selectedFlavorIndex(), true));
        });
  }
  function initBlock5(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock5) return;
    root.__nbpAssetBlock5 = true;
if (!root) return;

        const wrap = root.querySelector('.custom-loop-subscription-widget-inner');
        if (!wrap) return;

        function applyFlavor(flavorIndex) {
          wrap.setAttribute('data-flavor', String(flavorIndex));
          root.querySelectorAll('.custom-loop-subscription-widget-quantity').forEach(card => {
            const ms = card.querySelector('.js-money-saved');
            if (ms) ms.textContent = ms.dataset['flavor' + flavorIndex] || ms.dataset.flavor1 || ms.textContent;
          });
        }

        function currentFlavorIndex() {
          const radios = Array.from(root.querySelectorAll('input[name="flavour-image"]'));
          const idx = radios.findIndex(r => r.checked);
          return (idx === -1 ? 0 : idx) + 1;
        }

        applyFlavor(currentFlavorIndex());
        root.querySelectorAll('input[name="flavour-image"]').forEach(r => {
          r.addEventListener('change', () => applyFlavor(currentFlavorIndex()));
        });
  }
  function initBlock6(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock6) return;
    root.__nbpAssetBlock6 = true;
if (!root) return;
        const productJsonEl = root.querySelector('[data-nb-product-json]');
        if (!productJsonEl) return;

        let product;
        try { product = JSON.parse(productJsonEl.textContent); } catch(e) { return; }

        const optIdx = {
          flavor: (product.options || []).findIndex(n => /flavou?r/i.test(n)),
          qty: (product.options || []).findIndex(n => /(quantity|size|supply)/i.test(n))
        };

        function selFlavor() {
          const r = root.querySelector('input[name="flavour-image"]:checked');
          return r ? r.dataset.title : null;
        }

        function selQty() {
          const r = currentSupplyInput();
          return r ? r.dataset.title : null;
        }

        function selectedFlavorNumber() {
          const checked = root.querySelector('input[name="flavour-image"]:checked');
          if (!checked) return 1;
          const all = Array.from(root.querySelectorAll('input[name="flavour-image"]'));
          const idx = all.indexOf(checked);
          return idx >= 0 ? idx + 1 : 1;
        }

        function formatMoney(cents) {
          const value = Number(cents || 0);
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            try {
              return window.Shopify.formatMoney(value, (sectionRoot.getAttribute('data-nbp-money-format') || String.fromCharCode(36,123,123,97,109,111,117,110,116,125,125)));
            } catch (e) {}
          }
          try {
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD'
            }).format(value / 100);
          } catch (e) {
            return '$' + (value / 100).toFixed(2);
          }
        }

        function oneTimePriceForVariant(variant) {
          if (!variant) return '';
          const compare = Number(variant.compare_at_price || 0);
          const price = Number(variant.price || 0);
          return formatMoney(compare > price ? compare : price);
        }

        function findVariant() {
          const variants = product && Array.isArray(product.variants) ? product.variants : [];
          return variants.find(v => {
            const options = Array.isArray(v.options) ? v.options : [];
            const okQty = optIdx.qty < 0 || options[optIdx.qty] == selQty();
            const okFlv = optIdx.flavor < 0 || options[optIdx.flavor] == selFlavor();
            return okQty && okFlv;
          }) || null;
        }

        function currentSupplyInput() {
          const supplyInputs = Array.from(root.querySelectorAll('.nb-supply-option input[name="subscribe-save"]'));
          const storedTitle = root.dataset.selectedSupplyTitle || '';
          const storedSticks = root.dataset.selectedSupplySticks || '';
          const storedInput = storedTitle
            ? supplyInputs.find(input => input.dataset.title === storedTitle)
            : null;
          const storedSticksInput = storedSticks
            ? supplyInputs.find(input => {
                const value = input.dataset.sticks || input.dataset.bagSize || input.dataset.title || '';
                return String(value).replace(/\D/g, '') === String(storedSticks).replace(/\D/g, '');
              })
            : null;
          const checkedInput = supplyInputs.find(input => input.checked);
          const activeInput = supplyInputs.find(input => {
            const option = input.closest('.nb-supply-option');
            return option && option.classList.contains('is-active');
          });
          const popularInput = supplyInputs.find(input => {
            const value = input.dataset.sticks || input.dataset.bagSize || input.dataset.title || '';
            return String(value).replace(/\D/g, '') === '60';
          });
          return checkedInput || activeInput || storedInput || storedSticksInput || popularInput || supplyInputs[0] || null;
        }

        function digitsOnly(value) {
          return String(value || '').replace(/[^\d]/g, '');
        }

        function normalizeMoney(value) {
          const text = String(value || '').trim();
          if (!text) return '';
          if (text.indexOf('$') >= 0) return text;
          const number = Number(text.replace(/[^\d.]/g, ''));
          return Number.isFinite(number) && number > 0 ? '$' + number.toFixed(2) : text;
        }

        function supplyMeta(input) {
          const option = input ? input.closest('.nb-supply-option') : root.querySelector('.nb-supply-option.is-active');
          const readData = (key) => {
            const attr = 'data-' + key.replace(/[A-Z]/g, letter => '-' + letter.toLowerCase());
            return (input && input.dataset && input.dataset[key])
              || (option && option.dataset && option.dataset[key])
              || (input && input.getAttribute && input.getAttribute(attr))
              || (option && option.getAttribute && option.getAttribute(attr))
              || '';
          };
          const titleEl = option && option.querySelector('.nb-supply-title, .subscribe-Save-purchase-title');
          const subEl = option && option.querySelector('.nb-supply-subtitle, .subscribe-Save-purchase-price-per-bag');
          const titleText = titleEl ? titleEl.textContent.trim() : '';
          const subtitleText = subEl ? subEl.textContent.trim() : '';
          const rawSticks = readData('sticks') || readData('bagSize') || subtitleText || titleText;
          const sticks = digitsOnly(rawSticks) || digitsOnly(titleText) || digitsOnly(subtitleText) || root.dataset.selectedSupplySticks || '60';
          const rawDays = readData('days') || titleText || rawSticks;
          const days = digitsOnly(rawDays) || sticks;
          let oneTime = readData(`oneTimeFlavor${selectedFlavorNumber()}`) || readData('oneTime') || root.dataset.selectedSupplyOneTime || '';
          if (!oneTime) {
            oneTime = oneTimePriceForVariant(findVariant()) || '';
          }
          return {
            option,
            sticks,
            days,
            oneTime: normalizeMoney(oneTime),
            title: readData('title') || titleText
          };
        }

        function storeSupplySelection(input) {
          if (!input || input.name !== 'subscribe-save') return;
          const meta = supplyMeta(input);
          root.dataset.selectedSupplyTitle = input.dataset.title || meta.title || '';
          root.dataset.selectedSupplySticks = meta.sticks || '60';
          root.dataset.selectedSupplyDays = meta.days || meta.sticks || '60';
          root.dataset.selectedSupplyOneTime = meta.oneTime || '';
        }

        function selectSupplyInput(input) {
          if (!input || input.name !== 'subscribe-save') return;
          root.querySelectorAll('.nb-supply-option input[name="subscribe-save"]').forEach(radio => {
            const isActive = radio === input;
            radio.checked = isActive;
            if (isActive) {
              radio.setAttribute('checked', 'checked');
            } else {
              radio.removeAttribute('checked');
            }

            const option = radio.closest('.nb-supply-option');
            if (option) {
              option.classList.toggle('is-active', isActive);
            }
          });
          storeSupplySelection(input);
        }

        function updateOrderSummary(sourceInput) {
          let r = (sourceInput && sourceInput.name === 'subscribe-save') ? sourceInput : currentSupplyInput();
          if (!r) return;
          if (!r.checked) {
            selectSupplyInput(r);
          } else {
            storeSupplySelection(r);
          }
          const meta = supplyMeta(r);
          const sticks = meta.sticks || digitsOnly(r.dataset.sticks) || digitsOnly(root.dataset.selectedSupplySticks) || '60';
          const days = meta.days || digitsOnly(r.dataset.days) || digitsOnly(root.dataset.selectedSupplyDays) || sticks;
          const oneTime = meta.oneTime || normalizeMoney(r.dataset.oneTime || root.dataset.selectedSupplyOneTime || oneTimePriceForVariant(findVariant()) || '');
          root.dataset.selectedSupplySticks = sticks;
          root.dataset.selectedSupplyDays = days;
          if (oneTime) root.dataset.selectedSupplyOneTime = oneTime;
          const note = root.querySelector('[data-nb-order-note]');
          const oneTimeLink = root.querySelector('[data-nb-one-time-link]');
          if (note) {
            note.textContent = `Your Order: ${sticks} servings \u00B7 Delivered every ${days} days`;
          }
          if (oneTimeLink && oneTime) {
            oneTimeLink.textContent = `Or buy one-time for ${oneTime}`;
            oneTimeLink.setAttribute('aria-label', `Buy one-time for ${oneTime}`);
          }
        }

        function setImportant(el, styles) {
          if (!el) return;
          Object.keys(styles).forEach(prop => {
            el.style.setProperty(prop, styles[prop], 'important');
          });
        }

        function syncActiveClasses() {
          root.querySelectorAll('.nb-flavor-option').forEach(option => {
            const input = option.querySelector('input[name="flavour-image"]');
            option.classList.toggle('is-active', !!input && input.checked);
          });

          const supplyInputs = Array.from(root.querySelectorAll('.nb-supply-option input[name="subscribe-save"]'));
          const storedTitle = root.dataset.selectedSupplyTitle || '';
          let activeInput = supplyInputs.find(input => input.checked);

          if (!activeInput && storedTitle) {
            activeInput = supplyInputs.find(input => input.dataset.title === storedTitle);
          }

          if (!activeInput) {
            activeInput = supplyInputs.find(input => {
              const value = input.dataset.sticks || input.dataset.bagSize || input.dataset.title || '';
              return String(value).replace(/\D/g, '') === '60';
            }) || supplyInputs[0] || null;
          }

          supplyInputs.forEach(input => {
            const option = input.closest('.nb-supply-option');
            const isActive = input === activeInput;
            input.checked = isActive;
            if (isActive) {
              input.setAttribute('checked', 'checked');
              storeSupplySelection(input);
            } else {
              input.removeAttribute('checked');
            }

            const sticks = input.dataset.sticks || input.dataset.bagSize || '';
            const isPopular = String(sticks).replace(/\D/g, '') === '60';
            if (option) {
              option.classList.toggle('is-active', isActive);
              if (isPopular) {
                option.setAttribute('data-popular', 'true');
              } else {
                option.removeAttribute('data-popular');
              }
            }
          });
        }

        function hardenLiveLayout() {
          const isMobile = window.matchMedia('(max-width: 760px)').matches;
          const flavorCount = Math.max(1, root.querySelectorAll('.nb-flavor-option').length || 1);
          const desktopFlavorWidth = flavorCount <= 3 ? '98px' : '90px';
          const desktopFlavorHeight = flavorCount <= 3 ? '118px' : '112px';
          const desktopFlavorImgHeight = flavorCount <= 3 ? '74px' : '68px';
          const desktopFlavorColumns = `repeat(${Math.min(flavorCount, 5)}, ${desktopFlavorWidth})`;
          const mobileFlavorColumns = `repeat(${Math.min(flavorCount, 4)}, 78px)`;
          const flavorWidth = isMobile ? '78px' : desktopFlavorWidth;
          const flavorHeight = isMobile ? '100px' : desktopFlavorHeight;
          const flavorImgHeight = isMobile ? '62px' : desktopFlavorImgHeight;
          const flavorGap = isMobile ? '12px' : '20px';
          const flavorColumns = isMobile ? mobileFlavorColumns : desktopFlavorColumns;
          const headingFont = '"Lemon", Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif';
          const serifFont = '"Perfectly Nineties", Georgia, "Times New Roman", serif';
          const flavorHeadingFontSize = isMobile ? '15px' : '24px';
          const supplyHeadingFontSize = isMobile ? '15px' : '24px';
          const supplyTitleFontSize = isMobile ? '18px' : '22px';

          setImportant(root, {
            '--nb-heading-font': headingFont,
            '--nb-serif-font': serifFont,
            'background': 'var(--nb-active-bg)',
            'color': 'var(--nb-product-ink)'
          });

          const panel = root.querySelector('.nb-product-panel');
          if (panel) {
            setImportant(panel, {
              'display': 'block',
              'width': '100%',
              'max-width': '560px',
              'min-width': '0',
              'margin': isMobile ? '12px 0 0' : '0',
              'padding': '0',
              'background': 'transparent',
              'box-shadow': 'none',
              'border': '0',
              'overflow': 'visible',
              'box-sizing': 'border-box'
            });
          }

          const title = root.querySelector('.nb-product-title');
          if (title) {
            setImportant(title, {
              'display': 'block',
              'width': '100%',
              'max-width': isMobile ? '100%' : '560px',
              'min-width': '0',
              'margin': isMobile ? '0 0 17px' : '0 0 18px',
              'padding': '0',
              'color': 'var(--nb-product-ink)',
              'font-family': headingFont,
              'font-size': isMobile ? '38px' : '54px',
              'line-height': '.95',
              'font-weight': '700',
              'letter-spacing': '.2px',
              'text-transform': 'uppercase',
              'white-space': 'normal',
              'word-break': 'normal',
              'overflow-wrap': 'normal',
              'text-wrap': 'balance'
            });
          }

          root.querySelectorAll('.nb-product-description, .nb-product-description *').forEach(el => {
            const isDescription = el.classList && el.classList.contains('nb-product-description');
            setImportant(el, {
              'max-width': isMobile ? 'none' : '620px',
              'margin': '0',
              'padding': isDescription ? '0 0 24px' : '0',
              'color': 'var(--nb-product-ink)',
              'font-family': serifFont,
              'font-size': isMobile ? '24px' : '36px',
              'line-height': '1.08',
              'font-weight': '400',
              'letter-spacing': '0',
              'text-transform': 'none',
              'white-space': 'normal',
              'word-break': 'normal',
              'overflow-wrap': 'normal'
            });
          });

          root.querySelectorAll('.nb-product-description p, .nb-product-description div, .nb-product-description span').forEach(el => {
            setImportant(el, {
              'display': 'inline',
              'margin': '0',
              'padding': '0',
              'font-size': 'inherit',
              'line-height': 'inherit'
            });
          });

          root.querySelectorAll('.nb-product-description br').forEach(el => {
            setImportant(el, {
              'display': 'none'
            });
          });

          root.querySelectorAll('.nb-product-rule').forEach(el => {
            setImportant(el, {
              'display': 'none',
              'width': '100%',
              'height': '1px',
              'min-height': '1px',
              'margin': '0',
              'padding': '0',
              'border': '0',
              'background': 'transparent',
              'opacity': '0',
              'box-shadow': 'none'
            });
          });

          root.querySelectorAll('.custom-loop-subscription-widget, .custom-loop-subscription-widget-inner, .custom-loop-subscription-widget-inner-cover, .custom-loop-subscription-widget-flavour, .variant-select-wrapper, .nb-flavor-picker, .nb-flavor-grid, .nb-supply-picker, .nb-supply-grid, .subscribe-Save-purchase--box, .subscribe-Save-purchase--box-item, .subscribe-Save-purchase-accessories, .product-form, .product-form__buttons, .product-form__input, .form__label, fieldset, variant-radios, form[action*="/cart/add"]').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'max-width': 'none',
              'min-width': '0',
              'width': '100%',
              'height': 'auto',
              'min-height': '0',
              'margin': '0',
              'margin-left': '0',
              'margin-right': '0',
              'padding': '0',
              'border': '0',
              'background': 'transparent',
              'box-shadow': 'none',
              'box-sizing': 'border-box',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.loop-subscription-options-container, .loop-subscription-options, .loop-widget, .loop-widget-container, .loop-subscription-container, .loop-widget-purchase-option, .loop-widget-purchase-option-container, .loop-widget-purchase-options-container, .loop-widget-purchase-options, .loop-selling-plan-container, .loop-widget-selling-plan, .loop-selling-plan-options, .loop-container, .loop-subscription-group').forEach(el => {
            setImportant(el, {
              'position': 'absolute',
              'width': '1px',
              'height': '1px',
              'min-width': '0',
              'min-height': '0',
              'opacity': '0',
              'overflow': 'hidden',
              'pointer-events': 'none',
              'margin': '0',
              'padding': '0',
              'border': '0',
              'clip-path': 'inset(50%)'
            });
          });

          root.querySelectorAll('.nb-supply-option > .nb-supply-accessories > input[name="subscribe-save"], .nb-flavor-option > input[name="flavour-image"]').forEach(el => {
            setImportant(el, {
              'position': 'absolute',
              'display': 'block',
              'width': '1px',
              'height': '1px',
              'min-width': '0',
              'min-height': '0',
              'margin': '0',
              'padding': '0',
              'border': '0',
              'opacity': '0',
              'overflow': 'hidden',
              'pointer-events': 'none',
              'appearance': 'none',
              '-webkit-appearance': 'none'
            });
          });

          const flavorPicker = root.querySelector('.nb-flavor-picker');
          if (flavorPicker) {
            setImportant(flavorPicker, {
              'display': 'block',
              'position': 'relative',
              'width': '100%',
              'max-width': 'none',
              'padding': '0',
              'margin': isMobile ? '0 0 22px' : '0 0 22px',
              'border-top': '0',
              'border-bottom': '0',
              'background': 'transparent',
              'box-shadow': 'none',
              'overflow': 'visible'
            });
          }

          root.querySelectorAll('.nb-flavor-divider').forEach(el => {
            const dividerMargin = el.classList.contains('nb-flavor-divider--top')
              ? (isMobile ? '0 0 20px' : '0 0 23px')
              : (el.classList.contains('nb-flavor-divider--bottom') ? (isMobile ? '20px 0 0' : '22px 0 0') : '0');
            setImportant(el, {
              'display': 'block',
              'width': '100%',
              'height': '1px',
              'min-height': '1px',
              'flex': '0 0 1px',
              'margin': dividerMargin,
              'background': '#202020',
              'border': '0',
              'box-shadow': 'none',
              'opacity': '1',
              'pointer-events': 'none'
            });
          });

          root.querySelectorAll('.custom-loop-subscription-widget-flavour-title, .widget-plan-title, .widget-plan-title h4').forEach(el => {
            const isFlavorHeading = el.classList && el.classList.contains('custom-loop-subscription-widget-flavour-title');
            setImportant(el, {
              'display': 'block',
              'width': '100%',
              'max-width': 'none',
              'min-width': '0',
              'margin': '0 0 13px',
              'padding': '0',
              'border': '0',
              'background': 'transparent',
              'box-shadow': 'none',
              'color': 'var(--nb-product-ink)',
              'font-family': headingFont,
              'font-size': isFlavorHeading ? flavorHeadingFontSize : supplyHeadingFontSize,
              'line-height': '1',
              'font-weight': '700',
              'letter-spacing': '.01em',
              'text-transform': 'uppercase',
              'text-align': 'left',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed'
            });
          });

          const flavorGrid = root.querySelector('.nb-flavor-grid');
          if (flavorGrid) {
            setImportant(flavorGrid, {
              'display': 'grid',
              'grid-template-columns': flavorColumns,
              'gap': flavorGap,
              'justify-content': 'start',
              'align-items': 'start',
              'width': 'auto',
              'max-width': '100%',
              'margin': '0',
              'padding': '0',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'overflow': 'visible'
            });
          }

          root.querySelectorAll('.nb-flavor-option').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'position': 'relative',
              'width': flavorWidth,
              'min-width': flavorWidth,
              'max-width': flavorWidth,
              'height': flavorHeight,
              'min-height': flavorHeight,
              'max-height': flavorHeight,
              'margin': '0',
              'padding': '0',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'overflow': 'visible',
              'float': 'none',
              'cursor': 'pointer'
            });
          });

          root.querySelectorAll('.nb-flavor-card').forEach(el => {
            const option = el.closest('.nb-flavor-option');
            const checked = option && option.querySelector('input[name="flavour-image"]:checked');
            const active = !!checked || (option && option.classList.contains('is-active'));
            setImportant(el, {
              'display': 'block',
              'position': 'relative',
              'width': flavorWidth,
              'min-width': flavorWidth,
              'max-width': flavorWidth,
              'height': flavorHeight,
              'min-height': flavorHeight,
              'max-height': flavorHeight,
              'margin': '0',
              'padding': '0',
              'border': active ? '2px solid var(--nb-product-ink)' : '1px solid rgba(36,36,36,.08)',
              'border-radius': '8px',
              'background': 'var(--nb-flavor-bg, #f8d166)',
              'opacity': active ? '1' : '.68',
              'filter': active ? 'none' : 'saturate(.86) contrast(.9) brightness(1.02)',
              'overflow': 'visible',
              'cursor': 'pointer',
              'box-sizing': 'border-box'
            });
          });

          root.querySelectorAll('.nb-flavor-card-content').forEach(el => {
            setImportant(el, {
              'display': 'flex',
              'position': 'relative',
              'flex-direction': 'column',
              'justify-content': 'space-between',
              'align-items': 'stretch',
              'width': '100%',
              'height': '100%',
              'margin': '0',
              'padding': '8px 0 0',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'overflow': 'visible',
              'border-radius': 'inherit',
              'box-sizing': 'border-box'
            });
          });

          root.querySelectorAll('.nb-flavor-card-img').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'width': '100%',
              'height': flavorImgHeight,
              'margin': '0 auto',
              'padding': '8px',
              'object-fit': 'contain',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'box-sizing': 'border-box'
            });
          });

          root.querySelectorAll('.nb-flavor-card-title').forEach(el => {
            const option = el.closest('.nb-flavor-option');
            const checked = option && option.querySelector('input[name="flavour-image"]:checked');
            const active = !!checked || (option && option.classList.contains('is-active'));
            setImportant(el, {
              'display': 'grid',
              'place-items': 'center',
              'align-items': 'center',
              'justify-content': 'center',
              'width': '100%',
              'min-width': '100%',
              'max-width': '100%',
              'height': isMobile ? '36px' : '39px',
              'min-height': isMobile ? '36px' : '39px',
              'max-height': isMobile ? '36px' : '39px',
              'margin': '0',
              'padding': '0 2px 3px',
              'border-radius': '0 0 6px 6px',
              'background': active ? 'var(--nb-product-ink)' : '#fff',
              'color': active ? '#fff' : 'rgba(36,36,36,.7)',
              'font-family': headingFont,
              'font-size': isMobile ? '9px' : '18px',
              'line-height': '1',
              'font-weight': '900',
              'letter-spacing': '.14px',
              'text-transform': 'uppercase',
              'box-sizing': 'border-box',
              'white-space': 'nowrap',
              'text-align': 'center',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'position': 'absolute',
              'left': '0',
              'right': '0',
              'bottom': '-2px',
              'inset': 'auto 0 -2px 0',
              'inset-inline': '0',
              'transform': 'translateZ(0)',
              'overflow': 'hidden'
            });
          });

          root.querySelectorAll('.nb-supply-grid').forEach(el => {
            setImportant(el, {
              'display': 'grid',
              'grid-template-columns': '1fr',
              'gap': '12px',
              'width': '100%',
              'max-width': 'none',
              'margin': '0',
              'padding': '0',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'overflow': 'visible'
            });
          });

          root.querySelectorAll('.nb-supply-option, .nb-supply-accessories').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'position': 'relative',
              'width': '100%',
              'max-width': 'none',
              'min-width': '0',
              'height': 'auto',
              'min-height': '0',
              'margin': '0',
              'padding': '0',
              'border': '0',
              'background': 'transparent',
              'box-shadow': 'none',
              'overflow': 'visible',
              'float': 'none',
              'cursor': 'pointer'
            });
          });

          root.querySelectorAll('.nb-supply-card').forEach(el => {
            const option = el.closest('.nb-supply-option');
            const input = option ? option.querySelector('input[name="subscribe-save"]') : null;
            const active = !!input && input.checked;
            setImportant(el, {
              'display': 'block',
              'position': 'relative',
              'width': '100%',
              'max-width': 'none',
              'min-width': '0',
              'height': 'auto',
              'min-height': isMobile ? '74px' : '74px',
              'margin': '0',
              'padding': '0',
              'border': active ? '2px solid var(--nb-product-ink)' : '2px solid transparent',
              'border-radius': '8px',
              'background': active ? '#fff' : 'rgba(255,255,255,.78)',
              'box-shadow': 'none',
              'opacity': active ? '1' : '.58',
              'overflow': 'visible',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'cursor': 'pointer',
              'box-sizing': 'border-box',
              'transition': 'border-color .16s ease, opacity .16s ease, background .16s ease'
            });
          });

          root.querySelectorAll('.nb-supply-option:not(.is-active) .nb-plan-extra').forEach(el => {
            setImportant(el, {
              'display': 'none',
              'height': '0',
              'max-height': '0',
              'min-height': '0',
              'margin': '0',
              'padding': '0',
              'overflow': 'hidden',
              'opacity': '0'
            });
          });

          root.querySelectorAll('.nb-supply-accessories input[name="subscribe-save"]:not(:checked) + .nb-supply-card .nb-plan-extra').forEach(el => {
            setImportant(el, {
              'display': 'none',
              'height': '0',
              'max-height': '0',
              'min-height': '0',
              'margin': '0',
              'padding': '0',
              'overflow': 'hidden',
              'opacity': '0'
            });
          });

          root.querySelectorAll('.nb-supply-option.is-active .nb-plan-extra, .nb-supply-accessories input[name="subscribe-save"]:checked + .nb-supply-card .nb-plan-extra').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'height': 'auto',
              'max-height': 'none',
              'min-height': '0',
              'margin': '0',
              'padding': '0 16px 16px',
              'overflow': 'visible',
              'opacity': '1'
            });
          });

          root.querySelectorAll('.nb-supply-card-row').forEach(el => {
            setImportant(el, {
              'display': 'grid',
              'position': 'relative',
              'grid-template-columns': 'minmax(0,1fr) max-content',
              'align-items': 'center',
              'gap': isMobile ? '10px' : '12px',
              'width': '100%',
              'min-height': isMobile ? '74px' : '74px',
              'margin': '0',
              'padding': isMobile ? '14px 13px 14px 45px' : '16px 20px 15px 58px',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'box-sizing': 'border-box',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'top': 'auto',
              'left': 'auto',
              'right': 'auto',
              'bottom': 'auto',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-supply-card-row > div:first-child').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'position': 'static',
              'width': 'auto',
              'min-width': '0',
              'max-width': 'none',
              'margin': '0',
              'padding': '0',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'text-align': 'left',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-supply-card-row > *, .nb-supply-title-row, .nb-supply-price, .nb-plan-extra, .nb-plan-extra *, .nb-plan-perks, .nb-plan-perks *, .nb-gifts-list, .nb-gift-row, .nb-gift-row *').forEach(el => {
            setImportant(el, {
              'position': 'relative',
              'min-width': '0',
              'max-width': 'none',
              'margin-left': '0',
              'margin-right': '0',
              'float': 'none',
              'top': 'auto',
              'right': 'auto',
              'bottom': 'auto',
              'left': 'auto',
              'transform': 'none',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'box-sizing': 'border-box'
            });
          });

          root.querySelectorAll('.nb-supply-title-row').forEach(el => {
            setImportant(el, {
              'display': 'flex',
              'flex-flow': 'row nowrap',
              'align-items': 'center',
              'justify-content': 'flex-start',
              'gap': '8px',
              'min-width': '0',
              'margin': '0 0 3px',
              'padding': '0',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed'
            });
          });

          root.querySelectorAll('.nb-supply-title, .subscribe-Save-purchase-title').forEach(el => {
            setImportant(el, {
              'display': 'inline-block',
              'width': 'auto',
              'max-width': 'none',
              'min-width': '0',
              'margin': '0',
              'padding': '0',
              'color': 'var(--nb-product-ink)',
              'font-family': headingFont,
              'font-size': supplyTitleFontSize,
              'line-height': '.95',
              'font-weight': '700',
              'letter-spacing': '0',
              'text-transform': 'uppercase',
              'white-space': 'nowrap',
              'text-align': 'left',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-supply-badge, .subscribe-Save-purchase-accessories-price.js-money-saved').forEach(el => {
            setImportant(el, {
              'display': 'inline-flex',
              'align-items': 'center',
              'justify-content': 'center',
              'width': 'auto',
              'min-width': '52px',
              'height': '24px',
              'margin': '0',
              'padding': '0 9px',
              'border': '0',
              'border-radius': '4px',
              'background': 'var(--nb-product-red)',
              'color': '#fff',
              'font-family': headingFont,
              'font-size': '17px',
              'line-height': '1',
              'font-weight': '700',
              'letter-spacing': '0',
              'text-transform': 'uppercase',
              'white-space': 'nowrap',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-supply-subtitle, .subscribe-Save-purchase-price-per-bag').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'width': 'auto',
              'margin': '0',
              'padding': '0',
              'color': 'var(--nb-product-muted)',
              'font-family': serifFont,
              'font-size': '13px',
              'line-height': '1.1',
              'font-weight': '400',
              'letter-spacing': '0',
              'text-transform': 'none',
              'white-space': 'nowrap',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-supply-price').forEach(el => {
            setImportant(el, {
              'display': 'grid',
              'grid-template-columns': 'auto auto',
              'align-items': 'baseline',
              'justify-content': 'end',
              'column-gap': '6px',
              'row-gap': '4px',
              'min-width': isMobile ? '112px' : '130px',
              'margin': '0',
              'padding': '0',
              'text-align': 'right',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed'
            });
          });

          root.querySelectorAll('.nb-supply-price s, .nb-supply-price strong, .nb-supply-price small').forEach(el => {
            const isSmall = el.tagName.toLowerCase() === 'small';
            const isSale = el.tagName.toLowerCase() === 'strong';
            setImportant(el, {
              'display': isSmall ? 'block' : 'inline-block',
              'grid-column': isSmall ? '1 / -1' : 'auto',
              'width': 'auto',
              'max-width': 'none',
              'margin': '0',
              'padding': '0',
              'color': isSale ? 'var(--nb-product-red)' : 'var(--nb-product-muted)',
              'font-family': isSmall ? serifFont : headingFont,
              'font-size': isSmall ? '12px' : (isSale ? '21px' : '20px'),
              'line-height': isSmall ? '1.1' : '1',
              'font-weight': isSale ? '700' : '400',
              'letter-spacing': '0',
              'text-transform': isSmall ? 'none' : 'uppercase',
              'white-space': 'nowrap',
              'text-align': 'right',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-supply-price s').forEach(el => {
            setImportant(el, {
              'text-decoration-line': 'line-through',
              'text-decoration-thickness': '1.5px'
            });
          });

          root.querySelectorAll('.nb-plan-extra').forEach(el => {
            const option = el.closest('.nb-supply-option');
            const input = option ? option.querySelector('input[name="subscribe-save"]') : null;
            const active = !!input && input.checked;
            setImportant(el, {
              'display': active ? 'block' : 'none',
              'position': 'relative',
              'width': '100%',
              'max-width': 'none',
              'margin': '0',
              'padding': isMobile ? '0 13px 15px' : '0 18px 16px',
              'border': '0',
              'background': 'transparent',
              'box-shadow': 'none',
              'overflow': 'visible',
              'box-sizing': 'border-box',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'transform': 'none',
              'top': 'auto',
              'left': 'auto',
              'right': 'auto',
              'bottom': 'auto'
            });
          });

          root.querySelectorAll('.nb-plan-perks').forEach(el => {
            setImportant(el, {
              'display': 'grid',
              'position': 'relative',
              'grid-template-columns': isMobile ? 'repeat(3, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))',
              'gap': isMobile ? '8px' : '12px',
              'align-items': 'center',
              'width': '100%',
              'margin': '0 0 9px',
              'padding': '0 0 12px',
              'background': 'transparent',
              'border': '0',
              'border-bottom': '1px solid rgba(36,36,36,.14)',
              'box-shadow': 'none',
              'top': 'auto',
              'left': 'auto',
              'right': 'auto',
              'bottom': 'auto',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-plan-perks > div').forEach(el => {
            setImportant(el, {
              'display': 'inline-flex',
              'flex-direction': 'row',
              'align-items': 'center',
              'justify-content': 'center',
              'gap': '4px',
              'margin': '0',
              'padding': '0',
              'color': '#009a43',
              'font-family': serifFont,
              'font-size': isMobile ? '12px' : '14px',
              'line-height': '1.1',
              'white-space': 'nowrap',
              'text-align': 'center'
            });
          });

          root.querySelectorAll('.nb-plan-perks span').forEach(el => {
            setImportant(el, {
              'display': 'inline',
              'color': 'var(--nb-product-ink)',
              'font-family': serifFont,
              'font-size': isMobile ? '12px' : '13px',
              'line-height': '1.1',
              'font-weight': '400',
              'letter-spacing': '0',
              'text-transform': 'none',
              'white-space': 'nowrap'
            });
          });

          root.querySelectorAll('.nb-unlocked-gift').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'width': '100%',
              'margin': '0 0 10px',
              'padding': '0',
              'border-top': '0',
              'border-bottom': '0',
              'color': 'var(--nb-product-ink)',
              'font-family': headingFont,
              'font-size': isMobile ? '12px' : '18px',
              'line-height': '1',
              'font-weight': '700',
              'letter-spacing': '0',
              'text-transform': 'uppercase',
              'text-align': 'center',
              'white-space': 'normal'
            });
          });

          root.querySelectorAll('.nb-unlocked-gift strong').forEach(el => {
            setImportant(el, {
              'color': 'var(--nb-product-red)',
              'font-family': headingFont,
              'font-size': 'inherit',
              'line-height': 'inherit',
              'font-weight': '700',
              'letter-spacing': '0',
              'text-transform': 'uppercase'
            });
          });

          root.querySelectorAll('.nb-gift-row').forEach(el => {
            setImportant(el, {
              'display': 'grid',
              'position': 'relative',
              'grid-template-columns': isMobile ? '48px minmax(0,1fr) auto' : '58px minmax(0,1fr) auto',
              'align-items': 'center',
              'gap': isMobile ? '10px' : '12px',
              'width': '100%',
              'min-height': isMobile ? '64px' : '64px',
              'margin': '0 0 8px',
              'padding': isMobile ? '9px 10px' : '9px 12px',
              'border-radius': '8px',
              'background': 'var(--nb-gift-bg, #e8def4)',
              'border': '0',
              'box-shadow': 'none',
              'box-sizing': 'border-box',
              'overflow': 'hidden',
              'top': 'auto',
              'left': 'auto',
              'right': 'auto',
              'bottom': 'auto',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-gift-row img, .nb-gift-image-placeholder').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'width': '42px',
              'height': '42px',
              'min-width': '42px',
              'object-fit': 'contain',
              'margin': '0',
              'padding': '0',
              'background': 'transparent',
              'border': '0',
              'box-shadow': 'none'
            });
          });

          root.querySelectorAll('.nb-gift-row > span').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'min-width': '0',
              'margin': '0',
              'padding': '0',
              'color': 'var(--nb-product-ink)',
              'font-family': headingFont,
              'font-size': isMobile ? '12px' : '16px',
              'line-height': '1',
              'font-weight': '700',
              'letter-spacing': '0',
              'text-transform': 'uppercase',
              'text-align': 'left',
              'white-space': 'normal'
            });
          });

          root.querySelectorAll('.nb-gift-row small').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'margin': '4px 0 0',
              'padding': '0',
              'color': 'var(--nb-product-ink)',
              'font-family': serifFont,
              'font-size': isMobile ? '12px' : '13px',
              'line-height': '1.1',
              'font-weight': '400',
              'letter-spacing': '0',
              'text-transform': 'none',
              'text-align': 'left',
              'white-space': 'normal'
            });
          });

          root.querySelectorAll('.nb-gift-row > strong').forEach(el => {
            setImportant(el, {
              'display': 'block',
              'margin': '0',
              'padding': '0',
              'color': 'var(--nb-product-red)',
              'font-family': headingFont,
              'font-size': isMobile ? '12px' : '16px',
              'line-height': '1',
              'font-weight': '700',
              'letter-spacing': '0',
              'text-transform': 'uppercase',
              'white-space': 'nowrap',
              'text-align': 'right'
            });
          });

          root.querySelectorAll('.nb-atc-button').forEach(el => {
            setImportant(el, {
              'display': 'grid',
              'place-items': 'center',
              'width': '100%',
              'min-height': isMobile ? '60px' : '64px',
              'margin': isMobile ? '18px 0 0' : '22px 0 0',
              'padding': '0 22px',
              'border': '0',
              'border-radius': isMobile ? '13px' : '14px',
              'background': 'var(--nb-product-accent)',
              'color': '#fff',
              'font-family': headingFont,
              'font-size': isMobile ? '28px' : '28px',
              'line-height': '1',
              'font-weight': '900',
              'letter-spacing': '.1px',
              'text-transform': 'uppercase',
              'text-align': 'center',
              'cursor': 'pointer',
              'box-sizing': 'border-box'
            });
          });

          root.querySelectorAll('.nb-atc-button, .nb-atc-button *').forEach(el => {
            setImportant(el, {
              'font-family': headingFont,
              'font-size': isMobile ? '28px' : '28px',
              'line-height': '1',
              'font-weight': '900',
              'letter-spacing': '.1px',
              'text-transform': 'uppercase'
            });
          });

          root.querySelectorAll('[data-nb-order-note], [data-nb-one-time-link]').forEach(el => {
            const isOneTimeLink = el.matches('[data-nb-one-time-link], .nb-one-time-link');
            setImportant(el, {
              'display': 'block',
              'width': '100%',
              'margin': isOneTimeLink ? '4px 0 0' : (isMobile ? '10px 0 0' : '12px 0 0'),
              'padding': '0',
              'color': 'var(--nb-product-ink)',
              'font-family': serifFont,
              'font-size': isMobile ? '14px' : '16px',
              'line-height': '1.35',
              'font-weight': '400',
              'letter-spacing': '0',
              'text-transform': 'none',
              'text-align': 'center',
              'white-space': 'normal',
              'writing-mode': 'horizontal-tb',
              'text-orientation': 'mixed',
              'transform': 'none'
            });
          });

          root.querySelectorAll('.nb-accordion summary').forEach(el => {
            setImportant(el, {
              'font-family': serifFont,
              'font-size': isMobile ? '18px' : '20px',
              'line-height': '1.15',
              'font-weight': '400',
              'letter-spacing': '0',
              'text-transform': 'none',
              'color': 'var(--nb-product-ink)'
            });
          });

          root.querySelectorAll('.nb-accordion-body, .nb-accordion-body *').forEach(el => {
            setImportant(el, {
              'font-family': serifFont,
              'font-size': isMobile ? '16px' : '18px',
              'line-height': '1.34',
              'font-weight': '400',
              'letter-spacing': '0',
              'text-transform': 'none',
              'color': 'var(--nb-product-ink)',
              'white-space': 'normal',
              'word-break': 'normal',
              'overflow-wrap': 'normal'
            });
          });
        }

        root.__nbpHardenLiveLayout = hardenLiveLayout;

        function refreshOrderSummaryLater(sourceInput) {
          updateOrderSummary(sourceInput);
          window.setTimeout(() => updateOrderSummary(sourceInput), 40);
          window.setTimeout(() => updateOrderSummary(sourceInput), 160);
          window.setTimeout(() => updateOrderSummary(sourceInput), 420);
        }

        function updateUI(sourceInput) {
          const v = findVariant();
          if (v) {
            const btn = root.querySelector('[data-nb-atc-button]');
            if (btn) btn.dataset.variantId = v.id;
          }
          syncActiveClasses();
          hardenLiveLayout();
          refreshOrderSummaryLater(sourceInput);
        }

        function activateSupplyOption(option) {
          if (!option || !root.contains(option)) return null;
          const input = option.querySelector('input[name="subscribe-save"]');
          if (!input) return null;
          selectSupplyInput(input);
          syncActiveClasses();
          hardenLiveLayout();
          refreshOrderSummaryLater(input);
          return input;
        }

        root.addEventListener('pointerdown', (e) => {
          const option = e.target.closest('.nb-supply-option');
          if (!option || !root.contains(option)) return;
          activateSupplyOption(option);
        }, true);

        root.addEventListener('change', (e) => {
          if (!e.target || (e.target.name !== 'flavour-image' && e.target.name !== 'subscribe-save')) return;
          if (e.target.name === 'subscribe-save') {
            selectSupplyInput(e.target);
          }
          updateUI(e.target.name === 'subscribe-save' ? e.target : null);
        });

        root.addEventListener('input', (e) => {
          if (!e.target || (e.target.name !== 'flavour-image' && e.target.name !== 'subscribe-save')) return;
          if (e.target.name === 'subscribe-save') {
            selectSupplyInput(e.target);
          }
          updateUI(e.target.name === 'subscribe-save' ? e.target : null);
        });

        root.addEventListener('click', (e) => {
          const option = e.target.closest('.nb-flavor-option, .nb-supply-option');
          if (!option || !root.contains(option)) return;
          const input = option.querySelector('input[type="radio"]');
          if (!input) return;
          const isSupplyOption = input.name === 'subscribe-save';

          if (isSupplyOption) {
            e.preventDefault();
            e.stopPropagation();
          }

          if (input.name) {
            root.querySelectorAll('input[type="radio"]').forEach(radio => {
              if (radio.name !== input.name) return;
              radio.checked = false;
              radio.removeAttribute('checked');
              const radioCard = radio.closest('.nb-flavor-option, .nb-supply-option');
              if (radioCard) radioCard.classList.remove('is-active');
            });
          }
          input.checked = true;
          input.setAttribute('checked', 'checked');
          option.classList.add('is-active');
          if (isSupplyOption) {
            selectSupplyInput(input);
          }
          syncActiveClasses();
          hardenLiveLayout();
          updateOrderSummary(isSupplyOption ? input : null);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          if (isSupplyOption) {
            selectSupplyInput(input);
            updateOrderSummary(input);
          }

          syncActiveClasses();
          hardenLiveLayout();
          updateOrderSummary(isSupplyOption ? input : null);
          [0, 40, 120, 260, 520, 1000].forEach(delay => {
            window.setTimeout(() => {
              if (isSupplyOption) {
                selectSupplyInput(input);
              }
              updateUI(isSupplyOption ? input : null);
              updateOrderSummary(isSupplyOption ? input : null);
            }, delay);
          });
        });

        const loopRoot = root.querySelector('.loop-subscription-options');
        if (loopRoot) {
          const tryPick = () => {
            const radios = loopRoot.querySelectorAll('input[type="radio"][name="loop-subscription-option"]');
            if (!radios.length) return false;

            let chosen = Array.from(radios).find(r => {
              const lbl = loopRoot.querySelector(`label[for="${r.id}"]`);
              return lbl && /flexible plan|subscribe|save/i.test((lbl.textContent || ''));
            }) || radios[0];

            if (chosen && !chosen.checked) {
              chosen.checked = true;
              chosen.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return true;
          };

          if (!tryPick()) {
            const mo = new MutationObserver(() => {
              if (tryPick()) mo.disconnect();
            });
            mo.observe(loopRoot, { childList: true, subtree: true });
            window.setTimeout(() => {
              mo.disconnect();
            }, 9000);
          }
        }

        updateUI();
        [50, 250, 900, 1800].forEach(delay => {
          window.setTimeout(updateUI, delay);
        });
        window.addEventListener('resize', updateUI);

        const layoutObserver = new MutationObserver(() => {
          window.clearTimeout(root.__nbProductLayoutTimer);
          root.__nbProductLayoutTimer = window.setTimeout(updateUI, 80);
        });
        layoutObserver.observe(root, { childList: true, subtree: true });
        window.setTimeout(() => {
          layoutObserver.disconnect();
          window.clearTimeout(root.__nbProductLayoutTimer);
        }, 9000);
  }
  function initBlock7(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock7) return;
    root.__nbpAssetBlock7 = true;
if (!root || root.__nbProductShopifyFinal) return;
    root.__nbProductShopifyFinal = true;

    const money = value => {
      const text = String(value || '').trim();
      if (!text) return '';
      if (text.indexOf('$') >= 0) return text;
      const number = Number(text.replace(/[^\d.]/g, ''));
      return Number.isFinite(number) && number > 0 ? '$' + number.toFixed(2) : text;
    };

    const digits = value => String(value || '').replace(/[^\d]/g, '');

    function selectedFlavorIndex() {
      const checked = root.querySelector('input[name="flavour-image"]:checked');
      return checked && checked.dataset.flavorIndex ? checked.dataset.flavorIndex : '1';
    }

    function readOneTime(input) {
      if (!input) return '';
      const flavorValue = input.getAttribute('data-one-time-flavor' + selectedFlavorIndex()) || '';
      return money(flavorValue || input.getAttribute('data-one-time') || input.dataset.oneTime || '');
    }

    function supplyInputs() {
      return Array.from(root.querySelectorAll('.nb-supply-option input[name="subscribe-save"]'));
    }

    function activeSupplyInput() {
      const inputs = supplyInputs();
      return inputs.find(input => input.checked)
        || inputs.find(input => input.closest('.nb-supply-option') && input.closest('.nb-supply-option').classList.contains('is-active'))
        || inputs.find(input => digits(input.dataset.sticks || input.dataset.bagSize || input.dataset.title) === '60')
        || inputs[0]
        || null;
    }

    function syncSupply(input) {
      if (!input) return;
      supplyInputs().forEach(radio => {
        const isActive = radio === input;
        radio.checked = isActive;
        if (isActive) {
          radio.setAttribute('checked', 'checked');
        } else {
          radio.removeAttribute('checked');
        }
        const option = radio.closest('.nb-supply-option');
        if (option) option.classList.toggle('is-active', isActive);
      });
    }

    function updateOrderText(input) {
      const active = input || activeSupplyInput();
      if (!active) return;
      syncSupply(active);
      const sticks = digits(active.dataset.sticks || active.dataset.bagSize || active.dataset.title) || '60';
      const days = digits(active.dataset.days || active.dataset.title) || sticks;
      const oneTime = readOneTime(active);
      const note = root.querySelector('[data-nb-order-note]');
      const link = root.querySelector('[data-nb-one-time-link]');
      root.dataset.selectedSupplySticks = sticks;
      root.dataset.selectedSupplyDays = days;
      if (oneTime) root.dataset.selectedSupplyOneTime = oneTime;
      if (note) note.textContent = 'Your Order: ' + sticks + ' servings \u00B7 Delivered every ' + days + ' days';
      if (link && oneTime) {
        link.textContent = 'Or buy one-time for ' + oneTime;
        link.setAttribute('aria-label', 'Buy one-time for ' + oneTime);
      }
    }

    function syncFlavorClasses() {
      root.querySelectorAll('.nb-flavor-option').forEach(option => {
        const input = option.querySelector('input[name="flavour-image"]');
        option.classList.toggle('is-active', !!input && input.checked);
      });
    }

    function refresh(input) {
      syncFlavorClasses();
      updateOrderText(input);
    }

    root.addEventListener('click', event => {
      const supply = event.target.closest('.nb-supply-option');
      if (supply && root.contains(supply)) {
        const input = supply.querySelector('input[name="subscribe-save"]');
        if (input) {
          event.preventDefault();
          syncSupply(input);
          refresh(input);
        }
      }

      const flavor = event.target.closest('.nb-flavor-option');
      if (flavor && root.contains(flavor)) {
        const input = flavor.querySelector('input[name="flavour-image"]');
        if (input) {
          window.setTimeout(() => refresh(activeSupplyInput()), 20);
          window.setTimeout(() => refresh(activeSupplyInput()), 180);
        }
      }
    }, true);

    root.addEventListener('change', event => {
      if (event.target && event.target.name === 'subscribe-save') refresh(event.target);
      if (event.target && event.target.name === 'flavour-image') {
        window.setTimeout(() => refresh(activeSupplyInput()), 20);
        window.setTimeout(() => refresh(activeSupplyInput()), 180);
      }
    }, true);

    [0, 60, 240, 700, 1500].forEach(delay => {
      window.setTimeout(() => refresh(activeSupplyInput()), delay);
    });

    const observer = new MutationObserver(() => {
      window.clearTimeout(root.__nbProductShopifyFinalTimer);
      root.__nbProductShopifyFinalTimer = window.setTimeout(() => refresh(activeSupplyInput()), 80);
    });
    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => {
      observer.disconnect();
      window.clearTimeout(root.__nbProductShopifyFinalTimer);
    }, 9000);
  }
  function initBlock8(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock8) return;
    root.__nbpAssetBlock8 = true;
if (!root || root.__nbProductLastMile) return;
    root.__nbProductLastMile = true;

    function digits(value) {
      return String(value || '').replace(/[^\d]/g, '');
    }

    function normalizeMoney(value) {
      var text = String(value || '').trim();
      if (!text) return '';
      if (text.indexOf('$') !== -1) return text;
      var number = Number(text.replace(/[^\d.]/g, ''));
      return Number.isFinite(number) && number > 0 ? '$' + number.toFixed(2) : text;
    }

    function currentFlavorIndex() {
      var checked = root.querySelector('input[name="flavour-image"]:checked');
      return checked ? (checked.getAttribute('data-flavor-index') || '1') : '1';
    }

    function supplyInputs() {
      return Array.prototype.slice.call(root.querySelectorAll('.nb-supply-option input[name="subscribe-save"]'));
    }

    function activeSupply() {
      var inputs = supplyInputs();
      var fallback = inputs[0] || null;
      inputs.forEach(function(input) {
        var sticks = digits(input.getAttribute('data-sticks') || input.getAttribute('data-title'));
        if (sticks === '60') fallback = input;
      });
      for (var i = 0; i < inputs.length; i += 1) {
        if (inputs[i].checked) return inputs[i];
      }
      return fallback;
    }

    function oneTimePriceFor(input) {
      if (!input) return '';
      var flavorIndex = currentFlavorIndex();
      return normalizeMoney(
        input.getAttribute('data-one-time-flavor' + flavorIndex) ||
        input.getAttribute('data-one-time') ||
        ''
      );
    }

    function syncSupply(input) {
      input = input || activeSupply();
      if (!input) return;

      supplyInputs().forEach(function(item) {
        var isActive = item === input;
        item.checked = isActive;
        if (isActive) {
          item.setAttribute('checked', 'checked');
        } else {
          item.removeAttribute('checked');
        }
        var option = item.closest('.nb-supply-option');
        if (option) option.classList.toggle('is-active', isActive);
      });

      var title = input.getAttribute('data-title') || '';
      var sticks = digits(input.getAttribute('data-sticks') || input.getAttribute('data-bag-size') || title) || '60';
      var days = digits(input.getAttribute('data-days') || title) || sticks;
      var oneTime = oneTimePriceFor(input);
      var note = root.querySelector('[data-nb-order-note]');
      var link = root.querySelector('[data-nb-one-time-link]');

      if (note) note.textContent = 'Your Order: ' + sticks + ' servings \u00b7 Delivered every ' + days + ' days';
      if (link && oneTime) {
        link.textContent = 'Or buy one-time for ' + oneTime;
        link.setAttribute('aria-label', 'Buy one-time for ' + oneTime);
      }
    }

    root.addEventListener('click', function(event) {
      var supply = event.target.closest('.nb-supply-option');
      if (supply && root.contains(supply)) {
        var input = supply.querySelector('input[name="subscribe-save"]');
        if (input) {
          event.preventDefault();
          syncSupply(input);
        }
      }

      var flavor = event.target.closest('.nb-flavor-option');
      if (flavor && root.contains(flavor)) {
        setTimeout(function() { syncSupply(activeSupply()); }, 80);
        setTimeout(function() { syncSupply(activeSupply()); }, 240);
      }
    }, true);

    root.addEventListener('change', function(event) {
      if (event.target && event.target.name === 'subscribe-save') syncSupply(event.target);
      if (event.target && event.target.name === 'flavour-image') {
        setTimeout(function() { syncSupply(activeSupply()); }, 80);
      }
    }, true);

    [0, 80, 240, 700, 1600, 3000, 5000, 8000].forEach(function(delay) {
      setTimeout(function() { syncSupply(activeSupply()); }, delay);
    });

    var lastMileObserver = new MutationObserver(function() {
      clearTimeout(root.__nbProductLastMileTimer);
      root.__nbProductLastMileTimer = setTimeout(function() {
        syncSupply(activeSupply());
      }, 120);
    });
    lastMileObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked']
    });
    setTimeout(function() {
      lastMileObserver.disconnect();
      clearTimeout(root.__nbProductLastMileTimer);
    }, 9000);
  }
  function initBlock9(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock9) return;
    root.__nbpAssetBlock9 = true;
if (!root || root.__nbProductHardSync) return;
    root.__nbProductHardSync = true;

    function digits(value) {
      return String(value || '').replace(/[^\d]/g, '');
    }

    function money(value) {
      var text = String(value || '').trim();
      if (!text) return '';
      if (text.indexOf('$') !== -1) return text;
      var num = Number(text.replace(/[^\d.]/g, ''));
      return Number.isFinite(num) && num > 0 ? '$' + num.toFixed(2) : text;
    }

    function flavorIndex() {
      var checked = root.querySelector('input[name="flavour-image"]:checked');
      return checked ? (checked.getAttribute('data-flavor-index') || '1') : '1';
    }

    function supplyInputs() {
      return Array.prototype.slice.call(root.querySelectorAll('.nb-supply-option input[name="subscribe-save"]'));
    }

    function preferredSupply() {
      var inputs = supplyInputs();
      var fallback = inputs[0] || null;
      inputs.forEach(function(input) {
        if (digits(input.getAttribute('data-sticks') || input.getAttribute('data-title')) === '60') fallback = input;
      });
      return inputs.find(function(input) { return input.checked; }) || fallback;
    }

    function oneTimeFor(input) {
      if (!input) return '';
      return money(
        input.getAttribute('data-one-time-flavor' + flavorIndex()) ||
        input.getAttribute('data-one-time') ||
        ''
      );
    }

    function setActive(input) {
      input = input || preferredSupply();
      if (!input) return;

      supplyInputs().forEach(function(item) {
        var active = item === input;
        item.checked = active;
        item.toggleAttribute('checked', active);
        var option = item.closest('.nb-supply-option');
        if (option) option.classList.toggle('is-active', active);
      });

      var title = input.getAttribute('data-title') || '';
      var sticks = digits(input.getAttribute('data-sticks') || input.getAttribute('data-bag-size') || title) || '60';
      var days = digits(input.getAttribute('data-days') || title) || sticks;
      var oneTime = oneTimeFor(input);
      var note = root.querySelector('[data-nb-order-note]');
      var link = root.querySelector('[data-nb-one-time-link]');

      root.dataset.selectedSupplySticks = sticks;
      root.dataset.selectedSupplyDays = days;
      if (oneTime) root.dataset.selectedSupplyOneTime = oneTime;
      if (note) note.textContent = 'Your Order: ' + sticks + ' servings \u00b7 Delivered every ' + days + ' days';
      if (link && oneTime) {
        link.textContent = 'Or buy one-time for ' + oneTime;
        link.setAttribute('aria-label', 'Buy one-time for ' + oneTime);
      }
    }

    function inputFromTarget(target) {
      var option = target && target.closest ? target.closest('.nb-supply-option') : null;
      return option ? option.querySelector('input[name="subscribe-save"]') : null;
    }

    ['click', 'pointerup', 'touchend'].forEach(function(type) {
      root.addEventListener(type, function(event) {
        var input = inputFromTarget(event.target);
        if (input) {
          setActive(input);
        }
      }, true);
    });

    root.addEventListener('change', function(event) {
      if (event.target && event.target.name === 'subscribe-save') setActive(event.target);
      if (event.target && event.target.name === 'flavour-image') {
        setTimeout(function() { setActive(preferredSupply()); }, 40);
        setTimeout(function() { setActive(preferredSupply()); }, 180);
      }
    }, true);

    [0, 80, 240, 700, 1600, 3000, 5000, 8000].forEach(function(delay) {
      setTimeout(function() { setActive(preferredSupply()); }, delay);
    });

    var syncUntil = Date.now() + 9000;
    var interval = setInterval(function() {
      setActive(preferredSupply());
      if (Date.now() > syncUntil) clearInterval(interval);
    }, 500);

    var hardSyncObserver = new MutationObserver(function() {
      clearTimeout(root.__nbProductHardSyncTimer);
      root.__nbProductHardSyncTimer = setTimeout(function() {
        setActive(preferredSupply());
      }, 80);
    });
    hardSyncObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked']
    });
    setTimeout(function() {
      hardSyncObserver.disconnect();
      clearTimeout(root.__nbProductHardSyncTimer);
    }, 9000);
  }
  function initBlock10(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock10) return;
    root.__nbpAssetBlock10 = true;
if (!root || root.__nbProductFinalLiveSync) return;
    root.__nbProductFinalLiveSync = true;

    function digits(value) {
      return String(value || '').replace(/[^\d]/g, '');
    }

    function money(value) {
      var text = String(value || '').trim();
      if (!text) return '';
      return text.charAt(0) === '$' ? text : '$' + text.replace(/^\$/, '');
    }

    function flavorIndex() {
      var checked = root.querySelector('input[name="flavour-image"]:checked');
      return checked ? (checked.getAttribute('data-flavor-index') || '1') : (root.getAttribute('data-active-flavor') || root.dataset.activeFlavor || '1');
    }

    function supplyInputs() {
      return Array.prototype.slice.call(root.querySelectorAll('input[name="subscribe-save"]'));
    }

    function optionFor(input) {
      return input ? input.closest('.nb-supply-option, .subscribe-Save-purchase--box-item') : null;
    }

    function titleFor(input) {
      var option = optionFor(input);
      var title = option ? option.querySelector('.subscribe-Save-purchase-title, .nb-supply-title') : null;
      return (title && title.textContent) || input.getAttribute('data-title') || input.value || '';
    }

    function oneTimeFor(input) {
      if (!input) return '';
      return money(
        input.getAttribute('data-one-time-flavor' + flavorIndex()) ||
        input.getAttribute('data-one-time') ||
        input.dataset.oneTime ||
        ''
      );
    }

    function checkedSupply() {
      var all = supplyInputs();
      var checked = all.find(function(input) { return input.checked || input.hasAttribute('checked'); });
      if (checked) return checked;
      var sixty = all.find(function(input) {
        return digits(input.getAttribute('data-sticks') || input.getAttribute('data-bag-size') || titleFor(input)) === '60';
      });
      return sixty || all[0] || null;
    }

    function sync(input) {
      input = input || checkedSupply();
      if (!input) return;

      supplyInputs().forEach(function(item) {
        var active = item === input;
        item.checked = active;
        item.toggleAttribute('checked', active);
        item.setAttribute('aria-checked', active ? 'true' : 'false');
        var option = optionFor(item);
        if (option) {
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-checked', active ? 'true' : 'false');
        }
      });

      var title = titleFor(input);
      var sticks = digits(input.getAttribute('data-sticks') || input.getAttribute('data-bag-size') || title) || '60';
      var days = digits(input.getAttribute('data-days') || title) || sticks;
      var oneTime = oneTimeFor(input);
      var note = root.querySelector('[data-nb-order-note], .nb-order-note');
      var link = root.querySelector('[data-nb-one-time-link], .nb-one-time-link');

      root.dataset.selectedSupplySticks = sticks;
      root.dataset.selectedSupplyDays = days;
      if (oneTime) root.dataset.selectedSupplyOneTime = oneTime;

      if (note) note.textContent = 'Your Order: ' + sticks + ' servings \u00b7 Delivered every ' + days + ' days';
      if (link && oneTime) {
        link.textContent = 'Or buy one-time for ' + oneTime;
        link.setAttribute('aria-label', 'Buy one-time for ' + oneTime);
      }
    }

    root.addEventListener('click', function(event) {
      var option = event.target && event.target.closest ? event.target.closest('.nb-supply-option, .subscribe-Save-purchase--box-item') : null;
      if (!option || !root.contains(option)) return;
      var input = option.querySelector('input[name="subscribe-save"]');
      if (!input) return;
      sync(input);
    }, true);

    root.addEventListener('change', function(event) {
      if (event.target && event.target.name === 'subscribe-save') sync(event.target);
      if (event.target && event.target.name === 'flavour-image') {
        setTimeout(function() { sync(checkedSupply()); }, 30);
        setTimeout(function() { sync(checkedSupply()); }, 180);
      }
    }, true);

    [0, 80, 240, 700, 1500, 3000, 6000].forEach(function(delay) {
      setTimeout(function() { sync(checkedSupply()); }, delay);
    });

    var finalLiveObserver = new MutationObserver(function() {
      clearTimeout(root.__nbProductFinalLiveSyncTimer);
      root.__nbProductFinalLiveSyncTimer = setTimeout(function() {
        sync(checkedSupply());
      }, 80);
    });
    finalLiveObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked']
    });
    setTimeout(function() {
      finalLiveObserver.disconnect();
      clearTimeout(root.__nbProductFinalLiveSyncTimer);
    }, 9000);
  }
  function initBlock11(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock11) return;
    root.__nbpAssetBlock11 = true;
if (!root || root.__nbProductLivePolishV2) return;
    root.__nbProductLivePolishV2 = true;

    var fallbackOneTime = {
      '30': '$49.90',
      '60': '$79.84',
      '90': '$119.76',
      '120': '$180.00'
    };

    function digits(value) {
      var match = String(value || '').match(/\d+/);
      return match ? match[0] : '';
    }

    function money(value) {
      value = String(value || '').trim();
      if (!value) return '';
      if (value.charAt(0) === '$') return value;
      var number = Number(value.replace(/[^0-9.]/g, ''));
      if (!Number.isFinite(number) || number <= 0) return '';
      return '$' + number.toFixed(2);
    }

    function supplyOptions() {
      return Array.prototype.slice.call(root.querySelectorAll('.nb-supply-option, .subscribe-Save-purchase--box-item'));
    }

    function supplyInput(option) {
      return option ? option.querySelector('input[name="subscribe-save"], input[type="radio"]') : null;
    }

    function checkedOption() {
      var options = supplyOptions();
      var checked = options.find(function(option) {
        var input = supplyInput(option);
        return option.classList.contains('is-active') || (input && input.checked);
      });
      if (checked) return checked;
      var sixty = options.find(function(option) {
        return supplyMeta(option).sticks === '60';
      });
      return sixty || options[0] || null;
    }

    function titleText(option) {
      if (!option) return '';
      var title = option.querySelector('.nb-supply-title, .subscribe-Save-purchase-title, h3, h4, strong');
      return title ? title.textContent : option.textContent;
    }

    function supplyMeta(option) {
      var input = supplyInput(option);
      var card = option ? option.querySelector('.nb-supply-card, label') : null;
      var text = titleText(option);
      var sticks = digits((input && (input.getAttribute('data-sticks') || input.getAttribute('data-bag-size') || input.getAttribute('data-days'))) || (card && (card.getAttribute('data-sticks') || card.getAttribute('data-bag-size') || card.getAttribute('data-days'))) || text);
      if (!sticks && input) sticks = digits(input.value);
      var days = digits((input && input.getAttribute('data-days')) || (card && card.getAttribute('data-days')) || text) || sticks;
      var oneTime = money((input && (input.getAttribute('data-one-time') || input.dataset.oneTime)) || (card && card.getAttribute('data-one-time')) || option.getAttribute('data-one-time')) || fallbackOneTime[sticks] || '';
      return {
        sticks: sticks || '60',
        days: days || sticks || '60',
        oneTime: oneTime
      };
    }

    function setActive(option) {
      supplyOptions().forEach(function(item) {
        var active = item === option;
        var input = supplyInput(item);
        item.classList.toggle('is-active', active);
        item.classList.toggle('active', active);
        if (input) {
          if (input.checked !== active) input.checked = active;
          if (active && !input.hasAttribute('checked')) input.setAttribute('checked', 'checked');
          if (!active && input.hasAttribute('checked')) input.removeAttribute('checked');
        }
      });
    }

    function sync(option) {
      option = option || checkedOption();
      if (!option) return;
      setActive(option);
      var meta = supplyMeta(option);
      var note = root.querySelector('[data-nb-order-note], .nb-order-note');
      var link = root.querySelector('[data-nb-one-time-link], .nb-one-time-link');
      if (note) note.textContent = 'Your Order: ' + meta.sticks + ' servings \u00b7 Delivered every ' + meta.days + ' days';
      if (link && meta.oneTime) {
        link.textContent = 'Or buy one-time for ' + meta.oneTime;
        link.setAttribute('aria-label', 'Buy one-time for ' + meta.oneTime);
      }
    }

    root.addEventListener('click', function(event) {
      var option = event.target.closest('.nb-supply-option, .subscribe-Save-purchase--box-item');
      if (!option || !root.contains(option)) return;
      var input = supplyInput(option);
      if (input) {
        input.checked = true;
      }
      sync(option);
    }, true);

    root.addEventListener('change', function(event) {
      var option = event.target.closest('.nb-supply-option, .subscribe-Save-purchase--box-item');
      if (option) sync(option);
    }, true);

    var observer = new MutationObserver(function() {
      window.clearTimeout(root.__nbProductLivePolishTimer);
      root.__nbProductLivePolishTimer = window.setTimeout(function() {
        sync(checkedOption());
      }, 40);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'data-sticks', 'data-days', 'data-one-time']
    });
    window.setTimeout(function() {
      observer.disconnect();
      window.clearTimeout(root.__nbProductLivePolishTimer);
    }, 9000);

    sync(checkedOption());
    window.setTimeout(function() { sync(checkedOption()); }, 250);
    window.setTimeout(function() { sync(checkedOption()); }, 900);
  }

  function initBlock12(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpAssetBlock12) return;
    root.__nbpAssetBlock12 = true;

    var dataEl = root.querySelector('[data-nb-flavor-copy]');
    if (!dataEl) return;

    var copy = {};
    try {
      copy = JSON.parse(dataEl.textContent || '{}');
    } catch (error) {
      console.warn('Unable to parse flavor copy', error);
      return;
    }

    function selectedFlavorIndex() {
      var selected = root.querySelector('input[name="flavour-image"]:checked');
      return selected ? selected.getAttribute('data-flavor-index') || '1' : (root.getAttribute('data-active-flavor') || root.dataset.activeFlavor || '1');
    }

    function pickFlavorValue(map, flavorIndex) {
      if (!map) return '';
      return map[String(flavorIndex)] || map['1'] || '';
    }

    function applyFlavorCopy() {
      var flavorIndex = selectedFlavorIndex();
      var title = pickFlavorValue(copy.titles, flavorIndex);
      var titleEl = root.querySelector('[data-nb-dynamic-title], .nb-product-title');
      if (titleEl && title) titleEl.textContent = title;

      var description = pickFlavorValue(copy.descriptions, flavorIndex);
      var descriptionEl = root.querySelector('[data-nb-dynamic-description], .nb-product-description');
      if (descriptionEl && description) descriptionEl.innerHTML = description;

      var benefits = Array.isArray(copy.benefits) ? copy.benefits : [];
      Array.prototype.slice.call(root.querySelectorAll('[data-nb-benefit-title]')).forEach(function(benefitEl, index) {
        var benefit = benefits[index] || {};
        var benefitTitle = pickFlavorValue(benefit.titles, flavorIndex);
        if (benefitTitle) benefitEl.textContent = benefitTitle;
      });

      var accordions = Array.isArray(copy.accordions) ? copy.accordions : [];
      Array.prototype.slice.call(root.querySelectorAll('.nb-accordion')).forEach(function(accordion, index) {
        var item = accordions[index] || {};
        var heading = pickFlavorValue(item.headings, flavorIndex);
        var body = pickFlavorValue(item.bodies, flavorIndex);
        var headingEl = accordion.querySelector('[data-nb-accordion-heading]');
        var bodyEl = accordion.querySelector('[data-nb-accordion-body]');

        if (headingEl && heading) headingEl.textContent = heading;
        if (bodyEl && body) bodyEl.innerHTML = body;
      });
    }

    root.addEventListener('change', function(event) {
      if (event.target && event.target.name === 'flavour-image') applyFlavorCopy();
    });

    applyFlavorCopy();
    window.setTimeout(applyFlavorCopy, 80);
    window.setTimeout(applyFlavorCopy, 300);
  }

  function initSection(sectionRoot) {
    if (!sectionRoot) return;
    initBlock2(sectionRoot);
    initBlock3(sectionRoot);
    initBlock4(sectionRoot);
    initBlock5(sectionRoot);
    initBlock6(sectionRoot);
    initBlock7(sectionRoot);
    initBlock8(sectionRoot);
    initBlock9(sectionRoot);
    initBlock10(sectionRoot);
    initBlock11(sectionRoot);
    initBlock12(sectionRoot);
  }

  function initSectionWhenNeeded(sectionRoot) {
    if (!sectionRoot || sectionRoot.__nbpMainInitQueued) return;
    sectionRoot.__nbpMainInitQueued = true;

    function boot() {
      if (sectionRoot.__nbpMainInitDone) return;
      sectionRoot.__nbpMainInitDone = true;
      initSection(sectionRoot);
    }

    if (!('IntersectionObserver' in window) || !sectionRoot.getBoundingClientRect) {
      boot();
      return;
    }

    var rect = sectionRoot.getBoundingClientRect();
    if (rect.top < window.innerHeight + 900 && rect.bottom > -900) {
      boot();
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) {
        observer.disconnect();
        boot();
      }
    }, { rootMargin: '900px 0px 900px 0px' });

    observer.observe(sectionRoot);
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    if (scope.matches && scope.matches('[data-nbp-section]')) initSectionWhenNeeded(scope);
    scope.querySelectorAll('[data-nbp-section]').forEach(initSectionWhenNeeded);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

(function () {
  'use strict';

  function initHydrationNudge(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpHydrationNudge) return;
    root.__nbpHydrationNudge = true;

    var userInteracted = false;
    root.addEventListener('pointerdown', function(event) {
      if (event.isTrusted) userInteracted = true;
    }, true);

    function digits(value) {
      var match = String(value || '').match(/\d+/);
      return match ? match[0] : '';
    }

    function flavorInput() {
      var inputs = Array.prototype.slice.call(root.querySelectorAll('input[name="flavour-image"]'));
      return inputs.find(function(input) { return input.checked || input.hasAttribute('checked'); }) || inputs[0] || null;
    }

    function supplyInput() {
      var inputs = Array.prototype.slice.call(root.querySelectorAll('input[name="subscribe-save"]'));
      var checked = inputs.find(function(input) { return input.checked || input.hasAttribute('checked'); });
      if (checked) return checked;
      return inputs.find(function(input) {
        return digits(input.getAttribute('data-sticks') || input.getAttribute('data-bag-size') || input.getAttribute('data-title')) === '60';
      }) || inputs[0] || null;
    }

    function selectedLooksReady() {
      var flavor = flavorInput();
      var supply = supplyInput();
      var flavorOption = flavor && flavor.closest('.nb-flavor-option, .custom-loop-subscription-widget-flavour-box');
      var supplyOption = supply && supply.closest('.nb-supply-option, .subscribe-Save-purchase--box-item');
      var note = root.querySelector('[data-nb-order-note], .nb-order-note');
      var sticks = supply ? digits(supply.getAttribute('data-sticks') || supply.getAttribute('data-bag-size') || supply.getAttribute('data-title')) : '';
      return (!flavorOption || flavorOption.classList.contains('is-active')) &&
        (!supplyOption || supplyOption.classList.contains('is-active')) &&
        (!note || !sticks || note.textContent.indexOf(sticks + ' servings') !== -1);
    }

    function nudge() {
      if (userInteracted) return;

      var flavor = flavorInput();
      var supply = supplyInput();

      if (flavor) flavor.checked = true;
      if (supply) supply.checked = true;

      if (typeof root.__nbpHardenLiveLayout === 'function') {
        root.__nbpHardenLiveLayout();
      }
    }

    [60, 180, 420, 800, 1400, 2400, 3600, 5200].forEach(function(delay) {
      window.setTimeout(nudge, delay);
    });

    window.addEventListener('load', function() {
      window.setTimeout(nudge, 80);
      window.setTimeout(nudge, 420);
    });
  }

  function initHydrationWhenNeeded(sectionRoot) {
    if (!sectionRoot || sectionRoot.__nbpHydrationInitQueued) return;
    sectionRoot.__nbpHydrationInitQueued = true;

    function boot() {
      if (sectionRoot.__nbpHydrationInitDone) return;
      sectionRoot.__nbpHydrationInitDone = true;
      initHydrationNudge(sectionRoot);
    }

    if (!('IntersectionObserver' in window) || !sectionRoot.getBoundingClientRect) {
      boot();
      return;
    }

    var rect = sectionRoot.getBoundingClientRect();
    if (rect.top < window.innerHeight + 900 && rect.bottom > -900) {
      boot();
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) {
        observer.disconnect();
        boot();
      }
    }, { rootMargin: '900px 0px 900px 0px' });

    observer.observe(sectionRoot);
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    if (scope.matches && scope.matches('[data-nbp-section]')) initHydrationWhenNeeded(scope);
    scope.querySelectorAll('[data-nbp-section]').forEach(initHydrationWhenNeeded);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();

(function () {
  'use strict';

  function initSupplyStyleStabilizer(sectionRoot) {
    var root = sectionRoot.querySelector('[data-nb-product-section]') || sectionRoot;
    if (!root || root.__nbpSupplyStyleStabilizer) return;
    root.__nbpSupplyStyleStabilizer = true;

    var timer = 0;
    var raf = 0;

    function run() {
      if (typeof root.__nbpHardenLiveLayout === 'function') {
        root.__nbpHardenLiveLayout();
      }
    }

    function schedule() {
      run();

      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(run);

      window.clearTimeout(timer);
      timer = window.setTimeout(run, 80);
      window.setTimeout(run, 180);
    }

    function isWidgetEvent(event) {
      var target = event && event.target;
      return !!(target && target.closest && target.closest('.nb-supply-picker, .nb-supply-option, .nb-supply-card, .custom-loop-subscription-widget-quantity'));
    }

    ['pointerdown', 'click', 'input', 'change'].forEach(function(type) {
      root.addEventListener(type, function(event) {
        if (isWidgetEvent(event)) schedule();
      }, true);
    });

    var observer = new MutationObserver(function(mutations) {
      var shouldSchedule = mutations.some(function(mutation) {
        var target = mutation.target;
        return target && target.closest && target.closest('.nb-supply-picker, .nb-supply-option, .nb-supply-card');
      });
      if (shouldSchedule) schedule();
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked']
    });
    window.setTimeout(function() {
      observer.disconnect();
      window.clearTimeout(timer);
      if (raf) window.cancelAnimationFrame(raf);
    }, 9000);

    [0, 80, 240, 700, 1500].forEach(function(delay) {
      window.setTimeout(schedule, delay);
    });
  }

  function initSupplyStabilizerWhenNeeded(sectionRoot) {
    if (!sectionRoot || sectionRoot.__nbpSupplyStabilizerInitQueued) return;
    sectionRoot.__nbpSupplyStabilizerInitQueued = true;

    function boot() {
      if (sectionRoot.__nbpSupplyStabilizerInitDone) return;
      sectionRoot.__nbpSupplyStabilizerInitDone = true;
      initSupplyStyleStabilizer(sectionRoot);
    }

    if (!('IntersectionObserver' in window) || !sectionRoot.getBoundingClientRect) {
      boot();
      return;
    }

    var rect = sectionRoot.getBoundingClientRect();
    if (rect.top < window.innerHeight + 900 && rect.bottom > -900) {
      boot();
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) {
        observer.disconnect();
        boot();
      }
    }, { rootMargin: '900px 0px 900px 0px' });

    observer.observe(sectionRoot);
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    if (scope.matches && scope.matches('[data-nbp-section]')) initSupplyStabilizerWhenNeeded(scope);
    scope.querySelectorAll('[data-nbp-section]').forEach(initSupplyStabilizerWhenNeeded);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();